<template>
    <Tabs
        :tabs="stoneSearchTabs"
        selector-style
    />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { GemsApi_StoneCategory, type StoneShapeCode } from '@/graphql/api'
import { useRoutes } from '@/router/routes'

import type { TabsType } from '@/components/layout/Tabs'
import Tabs from '@/components/layout/Tabs.vue'

const props = defineProps<{
    shape: StoneShapeCode | undefined
}>()

const routes = useRoutes()

const stoneSearchTabs = computed((): TabsType<GemsApi_StoneCategory> => {
    return [
        {
            name: GemsApi_StoneCategory.Diamond,
            label: 'Natural',
            to: routes.diamondSearch(
                GemsApi_StoneCategory.Diamond,
                props.shape
            ),
        },
        {
            name: GemsApi_StoneCategory.LabGrownDiamond,
            label: 'Lab-Grown',
            to: routes.nonSku.labGrownDiamondSearch({
                shape: props.shape,
            }),
        },
        {
            name: GemsApi_StoneCategory.Gemstone,
            label: 'Gemstones',
            to: routes.nonSku.gemstoneSearch({
                shape: props.shape,
            }),
        },
    ]
})
</script>
